module.exports = __webpack_public_path__ + "static/img/lxwm_01.271ec12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lxwm_01.jpg
// module id = 8quU
// module chunks = 1